"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const local_storage_1 = require("../helpers/local-storage");
exports.createLocalStorageKey = (key) => `quiz:${key}`;
exports.entEmailKey = exports.createLocalStorageKey('entEmail');
exports.selRecencyKey = exports.createLocalStorageKey('selRecency');
exports.selReligionKey = exports.createLocalStorageKey('selReligion');
exports.selStateKey = exports.createLocalStorageKey('selState');
exports.didFinishQuiz = () => !!(local_storage_1.get(exports.entEmailKey) && local_storage_1.get(exports.selStateKey) && local_storage_1.get(exports.selReligionKey) && local_storage_1.get(exports.selRecencyKey));



// WEBPACK FOOTER //
// ./src/helpers/quiz.ts